const authService = require("./auth");

async function findNgos(query) {
    //headers
    var headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Accept", "application/json");
    headers.append("Authorization", `Bearer ${await authService.authFront()}`);
    var requestOptions = {
        method: 'GET',
        headers: headers,
    };

    let queryString = '?';

    Object.keys(query).forEach(key => {
        if (query[key] && query[key] != null && query[key] != '') {
            if (queryString != '?') {
                queryString += '&';
            }
            queryString += `${key}=${query[key]}`
        }
    });

    const req = await fetch(`${process.env.API_URL}/ongs/list/${queryString}`, requestOptions)

    return req.json();
}

module.exports = {
    findNgos
}
